import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_EVALUATIONS_SUMMARY } from '@/api/endpoints';
import { EVALUATIONS_SUMMARY_QUERY_KEY } from '@/api/queryKeys';
import type { EvaluationsSummary } from '@/types/overview';
import { unwrapAxiosResponse } from '@/utils/axios';

interface Options {
  enabled?: boolean;
}

export const useEvaluationsSummary = ({ enabled = true }: Options = {}) =>
  useQuery<EvaluationsSummary>({
    queryKey: EVALUATIONS_SUMMARY_QUERY_KEY,
    queryFn: () =>
      apiClient
        .get<EvaluationsSummary>(API_EVALUATIONS_SUMMARY)
        .then(unwrapAxiosResponse),
    enabled,
  });
